/* eslint-disable react/jsx-pascal-case */
import React, { useContext } from 'react'
import {
  Box,
  Button,
  Flex,
  Link,
  Text,
  getPaletteColor
} from 'pcln-design-system'
import styled from 'styled-components'
import RotatingBanner from '@/components/RotatingBanner'
import FlightLogoBannerSrc from '@/images/airlines/flights_logo_bumper.jpg'
import RentalCarsLogoBannerSrc from '@/images/rental-cars/rcBumper.png'
import useExpressDealModal from '@/hooks/useExpressDealModal'
import ExpressDealModal from '@/components/Flights/ExpressDeal/ExpressDealModal'
import { ANALYTICS_CATEGORY_HOME } from '@/constants/analytics'
import {
  SearchFormContext,
  SearchFormContextType
} from '@/context/SearchFormContext'
import { HOTEL_FORM_STATE_TYPE } from '../Hotels/types'
import { formatShopSearchLink } from '../Hotels/SearchForm/utils'
import ConditionalRender, { Experiment, Original } from '../ConditionalRender'

const Wrapper = styled(Box).attrs(() => ({
  p: 3
}))`
  border-top: 1px solid ${getPaletteColor('border.base')};
`

export function FlightsBumper() {
  const { isOpen, openModal } = useExpressDealModal()
  return (
    <Wrapper>
      <Button
        color="transparent"
        onClick={openModal}
        p={0}
        width={1}
        aria-label="Save up to 50% by searching Express Deals."
        data-testid="flight-express-deal-bumper"
      >
        <ExpressDealModal
          isModalOpen={isOpen}
          gaCategory={ANALYTICS_CATEGORY_HOME}
        />
        <RotatingBanner
          height="25px"
          image={FlightLogoBannerSrc}
          primaryBannerText="Save up to 50% by searching Express Deals."
          secondaryBannerText="Trusted airlines, incredible deals."
        />
      </Button>
    </Wrapper>
  )
}

export function CarsBumper() {
  return (
    <Wrapper>
      <RotatingBanner
        height="25px"
        image={RentalCarsLogoBannerSrc}
        primaryBannerText="Save up to 40% by searching Express Deals."
        secondaryBannerText="Trusted brands, incredible deals."
      />
    </Wrapper>
  )
}

export function VacationBumper() {
  return (
    <Wrapper>
      <Text fontSize={1} textAlign="center" color="text.light">
        Save up to $625 when you book your hotel and flight together!
      </Text>
    </Wrapper>
  )
}

export function CruiseBumper() {
  return (
    <Wrapper>
      <Text fontSize={1} textAlign="center" color="text.light">
        Get up to $1,000 to spend at sea when you&nbsp;
        <Text.span fontWeight="bold" color="primary">
          <Link
            href="https://cruises.priceline.com?utm_medium=partner_site_banner&utm_source=pcln-partner_site&utm_campaign=20190307&utm_content=widget_link"
            target="_blank"
          >
            book a cruise with Priceline.
          </Link>
        </Text.span>
      </Text>
    </Wrapper>
  )
}

export function HotelsBumper() {
  const { formValues } = useContext<
    SearchFormContextType<HOTEL_FORM_STATE_TYPE>
  >(
    SearchFormContext as React.Context<
      SearchFormContextType<HOTEL_FORM_STATE_TYPE>
    >
  )

  return (
    <ConditionalRender
      experimentCode="PKG_FE_HOTEL_HOTEL_LANDING"
      variantValue="VARIANT"
    >
      <Experiment>
        <Wrapper>
          <Text fontSize={1}>
            <Flex flexWrap="wrap" justifyContent="center">
              <ConditionalRender
                experimentCode="PKG_FE_IMPROVE_MULTI_HOTEL_COPYING"
                variantValue="VARIANT"
              >
                <Original>
                  <Text.span color="text.light">
                    On a multi-destination trip?&nbsp;
                  </Text.span>
                  <Text.span fontWeight="bold" color="primary">
                    <Link
                      href={formatShopSearchLink(formValues)}
                      target="_blank"
                    >
                      Book up to five hotel stays
                    </Link>
                  </Text.span>
                </Original>
                <Experiment>
                  <Text.span fontWeight="bold" color="primary">
                    <Link
                      href={formatShopSearchLink(formValues)}
                      target="_blank"
                    >
                      Book up to 5 hotels at the same time
                    </Link>
                  </Text.span>
                </Experiment>
              </ConditionalRender>
            </Flex>
          </Text>
        </Wrapper>
      </Experiment>
    </ConditionalRender>
  )
}
